/* eslint-disable no-unused-vars */
import React from 'react'
import GenericModal from './GenericModal'
import R from 'ramda'
import styled from 'styled-components'
import { Button, Collapse, message } from 'antd'
import ValidationError from './ValidationError'
import { Filler } from '../screen-util'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  isStackTraceAllowed,
} from 'core/selectors'
import { exportData, hasAccesPermits } from 'core/utils'
import { getErrorTraceLogblob } from 'api/pgads'
import * as ScreenPermissions from 'core/EventActions'
import moment from 'moment'

const StackTrace = styled.pre`
  height: 45vh;
  overflow: auto;
  word-wrap: normal;
  white-space: pre;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0.5em 0.5em;
  max-width: 90vw;
  max-height: 80vh;
`

const ErrorDiv = styled.div`
  color: #c13d1c;
  font-weight: bold;
  font-size: 1.15em;
`

const HttpError = ({ errorMsg, targetUrl, stackTrace }) =>
  stackTrace ? (
    <StrackTraceError
      {...{ errorMsg: `${errorMsg} reaching ${targetUrl}`, stackTrace }}
    />
  ) : (
    <ErrorDiv data-testid="error-panel">
      {errorMsg} reaching <a href={targetUrl}>{targetUrl}</a>
    </ErrorDiv>
  )
//
//
//
class StrackTraceError extends React.Component {
  state = { showDetail: false }

  toggleShowDetail = _ =>
    this.setState(({ showDetail }) => ({ showDetail: !showDetail }))

  render() {
    const { errorMsg, stackTrace } = this.props

    return (
      <div data-testid="error-panel">
        <div style={{ display: 'flex', marginBottom: '10px' }}>
          <ErrorDiv>{errorMsg}</ErrorDiv>
          <Filler />
          {/* {this.props.httpStatus === 403 && (
            <Button type={'danger'} onClick={logout}>
              Logout
            </Button>
          )} */}
        </div>
        <Collapse accordion>
          <Collapse.Panel header="Click for Detail">
            <StackTrace>{stackTrace}</StackTrace>
          </Collapse.Panel>
        </Collapse>
      </div>
    )
  }
}

class HideStackTrace extends React.Component {
  state = { showDetail: false }

  toggleShowDetail = _ =>
    this.setState(({ showDetail }) => ({ showDetail: !showDetail }))

  render() {
    const { errorMsg, stackTrace } = this.props

    const showDownload =
      !this.props.stackTraceAllowed &&
      hasAccesPermits({
        actionPermits: this.props.actionPermits,
        eventActions: [
          ScreenPermissions.ERROR_LOG_SCREEN_USER,
          ScreenPermissions.ERROR_LOG_SCREEN_ADMIN,
        ],
        matchAny: true,
      })

    let urlLoc = window.location.origin
    urlLoc =
      urlLoc.charAt(urlLoc.length - 1) === '/'
        ? urlLoc.substring(0, urlLoc.length - 1)
        : urlLoc

    const finalUrl = `${urlLoc}/errortraceuser?id=${stackTrace
      .substr(stackTrace.indexOf(':') + 1)
      .trim()}`

    console.log(finalUrl)
    return (
      <div data-testid="error-panel">
        <div
          style={{
            marginBottom: '10px',
            display: 'grid',
            gridTemplateColumns: '1fr',
          }}
        >
          <ErrorDiv errorMsg={stackTrace}>{stackTrace}</ErrorDiv>
          <a target="_blank" href={finalUrl} rel="noreferrer">
            <div
              style={{
                // color: 'blue',
                fontSize: '16px',
                fontWeight: '400',
              }}
            >
              View Error
            </div>
          </a>
          {showDownload && false && (
            <a
              style={{ marginTop: '10px', marginBottom: '10px' }}
              target="_self"
              onClick={_ => {
                const id = stackTrace.substr(stackTrace.indexOf(':') + 1).trim()
                getErrorTraceLogblob(this.props.targetInfo)({ id }).fork(
                  e => console.log(e),
                  err => {
                    const blob = new Blob([err])
                    exportData(blob, 'text/plain', `${id}.txt`)
                  }
                )
              }}
            >
              Download Error
            </a>
          )}
          <ErrorDiv>Error : {errorMsg}</ErrorDiv>
        </div>
      </div>
    )
  }
}

const MsgOnly = ({ errorMsg }) => (
  <div data-testid="error-panel">{errorMsg}</div>
)
//
class JsError extends React.Component {
  state = { showDetail: false }

  toggleShowDetail = _ =>
    this.setState(({ showDetail }) => ({ showDetail: !showDetail }))

  render() {
    const { err } = this.props
    return (
      <div data-testid="error-panel">
        <ErrorDiv>{err.message && err.message}</ErrorDiv>
        {err.stack && (
          <Collapse accordion>
            <Collapse.Panel header="Click for Detail">
              <StackTrace>{err.stack}</StackTrace>
            </Collapse.Panel>
          </Collapse>
        )}
      </div>
    )
  }
}
//
export const ErrorPanel = ({
  modalInfo,
  errorRenderer,
  stackTraceAllowed = true,
  targetInfo,
  ...rest
}) => {
  const isHttpError = modalInfo.httpError
  const hasStackTrace = modalInfo.stackTrace
  const hasValidationError =
    modalInfo.validationError && modalInfo.validationError.length > 0
  const hasMsg = modalInfo.errorMsg
  // const jsError = !modalInfo.restfulStatus
  const isString = typeof modalInfo === 'string'

  return isString ? (
    <ErrorDiv>{modalInfo}</ErrorDiv>
  ) : isHttpError ? (
    <HttpError {...modalInfo} />
  ) : stackTraceAllowed === false ? (
    <HideStackTrace
      {...modalInfo}
      stackTraceAllowed={stackTraceAllowed}
      targetInfo={targetInfo}
      {...rest}
    />
  ) : hasStackTrace ? (
    <StrackTraceError {...modalInfo} stackTraceAllowed={stackTraceAllowed} />
  ) : hasValidationError ? (
    <ValidationError {...{ errorRenderer, ...modalInfo }} />
  ) : hasMsg ? (
    <MsgOnly {...modalInfo} />
  ) : (
    <JsError err={modalInfo} />
  )
}

const ErrorModal = ({
  modalInfo,
  setModalInfo,
  stackTraceAllowed,
  ...rest
}) => {
  return (
    <GenericModal
      testId="error"
      onClose={_ => setModalInfo(null)}
      open={!R.isNil(modalInfo)}
      modalInfo={modalInfo}
      size="small"
      {...rest}
      title={
        modalInfo && modalInfo.restfulStatus === 'WARNING'
          ? 'Warning'
          : 'Error / Warning'
      }
      // extButton={
      // this is not worked on server  so need to hide this
      //   window.navigator.clipboard
      //     ? [
      //         <Button
      //           key="copybtnmodal"
      //           type="primary"
      //           onClick={_ => {
      //             window.navigator.clipboard &&
      //               window.navigator.clipboard
      //                 .writeText(JSON.stringify(modalInfo))
      //                 .then(() => {
      //                   message.info('Data Copied.')
      //                 })
      //                 .catch(e => console.log(e))
      //                 .finally(_ => setModalInfo(false))
      //           }}
      //         >
      //           Copy & Hide
      //         </Button>,
      //       ]
      //     : []
      // }
    >
      {props => (
        <ErrorPanel
          {...props}
          errorRenderer={rest.errorRenderer}
          stackTraceAllowed={stackTraceAllowed}
          envConfig={rest.envConfig}
          actionPermits={rest.actionPermits}
        />
      )}
    </GenericModal>
  )
}
//

const mapStatetoProps = state => ({
  stackTraceAllowed: isStackTraceAllowed(state),
  targetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
})
export default connect(mapStatetoProps)(ErrorModal)
